import authBaseHttpRequest from './authBaseHttpRequest';

export const userProfile = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/signup/user/',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const submitComplaint = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: '/ticket/',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const updateProfile = ({ params }) => {
  return authBaseHttpRequest({
    method: 'patch',
    url: '/signup/user/update/',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

export const submitFinchAccessToken = ({ params }) => {
  return authBaseHttpRequest({
    method: 'post',
    url: '/finch/save-access-token/',
    headers: {
      'Content-Type': 'application/json',
    },
    data: params,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
